import { render } from "./job-grid-modal.vue?vue&type=template&id=ed21fedc"
import script from "./job-grid-modal.vue?vue&type=script&lang=js"
export * from "./job-grid-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__